/*
 * Review link.
 *
 * /products/<handle>#write-review opens Judge.me's review form on arrival. It
 * is the address behind the QR code on the card in each box, so someone who
 * scans it is one tap from the stars and not at the top of a product page they
 * have already bought from. It works as a plain link anywhere else too: an
 * email, an order page.
 *
 * The form is Judge.me's and so is the button that opens it. Their widget
 * arrives server rendered, so the button is in the page long before their
 * script has given it a click handler, and a click made too early does
 * nothing. So this clicks, watches for the form, and clicks again every second
 * and a half for about twelve seconds, then gives up quietly: the visitor is
 * left at the reviews with the button in front of them. The clicks are that
 * far apart because a click that did land may still take a moment to draw the
 * form, and a second one on top of it is not wanted.
 *
 * Once the form is open the address changes to #reviews. A reload then lands
 * on the reviews and does not throw the form up a second time, and a later
 * link to #write-review on the same page is a real hash change again.
 *
 * Both selectors name Judge.me's markup, which is theirs to rename. If the
 * link ever lands on the reviews without opening the form, start here.
 */
(function () {
  'use strict';

  var HASH = '#write-review';
  var BUTTON = '.peanut-reviews__widget .jm-button--primary';
  var FORM = '.jdgm-write-review-modal';
  var LOOK_EVERY = 300;
  var CLICK_EVERY = 5; // in looks, so 1500ms
  var LOOKS = 40;

  var timer = null;

  function formIsOpen() {
    var form = document.querySelector(FORM);
    return !!form && window.getComputedStyle(form).display !== 'none';
  }

  function arrive() {
    if (window.location.hash !== HASH) return;

    var section = document.getElementById('reviews');
    if (!section) return;

    // The reviews go behind the form, so closing it leaves the visitor there
    // and not wherever the page happened to be. 'instant' for the reason given
    // in peanut-anchor-scroll.js: this is an arrival, not a journey to watch.
    section.scrollIntoView({ behavior: 'instant', block: 'start' });

    var looks = 0;
    window.clearInterval(timer);

    timer = window.setInterval(function () {
      if (formIsOpen()) {
        window.clearInterval(timer);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.hash = 'reviews';
          window.history.replaceState({}, '', url.toString());
        }
        return;
      }

      if (looks >= LOOKS) {
        window.clearInterval(timer);
        return;
      }

      if (looks % CLICK_EVERY === 0) {
        var button = section.querySelector(BUTTON);
        if (button) button.click();
      }
      looks += 1;
    }, LOOK_EVERY);
  }

  arrive();
  window.addEventListener('hashchange', arrive);
})();
